export default {
  ess_language: {
    language: {
      en_US: 'English (US)',
      es_ES: 'Español',
      jp_JP: '日本語'
    }
  }
}
